export default {
  root: {
    class: [
      'w-screen h-12 md:w-full',

      // Flexbox
      'flex',
      'items-center',
      'justify-between',

      // Color
      'dark:bg-surface-900',

      //Text
      'text-xl font-default'
    ]
  },
  menu: ({ props }) => ({
    class: [
      // Flexbox
      'md:flex',
      'md:items-center',
      'flex-col md:flex-row',
      { hidden: !props?.mobileActive, flex: props?.mobileActive },

      // Position
      'absolute md:relative',
      'top-full left-0',
      'md:top-auto md:left-auto',

      // Size
      'w-full md:h-full',

      // Spacing
      'm-0',
      'md:py-0 md:p-0',
      'list-none',

      // Shape
      'shadow-md md:shadow-none',
      'border-0',

      // Color
      'bg-primary-400 dark:bg-surface-900 md:bg-transparent',

      // Misc
      'outline-none'
    ]
  }),
  menuitem: {
    class: 'static md:relative w-full h-full md:w-auto text-nowrap'
  },
  content: ({ context }) => ({
    class: [
      'flex h-full',

      //  Colors
      {
        'text-white dark:text-white/70': context.level < 1,
        'text-surface-900': context.level >= 1,
        'text-white dark:text-surface-50/80 bg-blue-500 dark:bg-primary-400/30': context.active
      },

      // Hover States
      {
        'hover:bg-blue-500 dark:hover:bg-surface-600/80': !context.active,
        'hover:bg-blue-500 dark:hover:bg-primary-300/30 text-white dark:text-surface-50/80':
          context.active,
        'hover:bg-gray-100 hover:!outline-0': context.level >= 1,
        'hover:bg-primary-400': context.item.item.key === 'license-banner'
      },

      // Focus state
      {
        'bg-blue-500': context.focused && !context.active && context.level < 1,
        'bg-surface-300': context.focused && !context.active && context.level >= 1
      },

      // Transitions
      'transition-all',
      'duration-200'
    ]
  }),
  action: ({ context }) => ({
    class: [
      'relative',

      // Font
      {
        'text-md': context.level >= 1
      },

      // Flexbox
      'flex',
      'items-center',

      // Spacing
      {
        'py-3 px-3': context.level < 1,
        'py-2 px-3': context.level >= 1
      },

      // Size
      {
        'pl-9 md:pl-5': context.level === 1,
        'pl-14 md:pl-5': context.level === 2
      },
      'leading-none',

      // Misc
      'select-none',
      'cursor-pointer',
      'no-underline ',
      'overflow-hidden'
    ]
  }),
  icon: {
    class: 'order-2 ml-2'
  },
  start: {
    class: 'flex self-stretch'
  },
  submenu: ({ props }) => ({
    class: [
      'md:rounded-b-xs',

      // Size
      'min-w-full',
      'min-w-40',

      // Spacing
      'm-0',
      'list-none',

      // Shape
      'shadow-none md:shadow-md',
      'border-0',

      // Position
      'static md:absolute',
      'z-10',
      { 'md:absolute md:left-full md:top-0': props.level > 1 },

      // Color
      'bg-surface-50 dark:bg-surface-700'
    ]
  }),
  separator: {
    class: 'h-px bg-gray-300 my-1.5'
  },
  button: () => ({
    class: [
      // Flexbox
      'flex md:hidden',
      'items-center justify-center',

      // Size
      'w-8',
      'h-8',

      // Color
      'text-white dark:text-white/80',

      // States
      'hover:text-surface-600 dark:hover:text-white/60',
      'hover:bg-blue-500 dark:hover:bg-surface-600/80',
      'focus-visible:outline-none focus-visible:outline-offset-0',
      'focus-visible:ring focus-visible:ring-primary-400/80 dark:focus-visible:ring-primary-300/50',

      // Transitions
      'transition duration-200 ease-in-out',

      // Misc
      'cursor-pointer',
      'no-underline'
    ]
  }),
  end: {
    class: 'grow justify-between flex flex-row'
  }
}
